module.exports = __webpack_public_path__ + "static/img/green.e72a4ca.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeimg/green.gif
// module id = 59Sp
// module chunks = 1